export class assignToCustomer{
    
    customerId:string;
    active:Boolean;
    executiveid:string;
    
}